import Observer from "../../form-app/services/Observer";

/**
 * 
 * @param {HTMLElement | Element | Node} dom 
 * @param {() => void} cb 
 * @param { any | null} args - passing any arguments
 * @returns {() => void} - Return Unsubcribe
 */
export const useSubscribeDOMRendered = (dom, cb, args) => {
    const unsubscribe = Observer.SubscribeDOMRendered(dom, (args) => {
        if (typeof cb === 'function') {
            cb.call(null, args);
        }
    }, args)
    return unsubscribe;
};


